module.exports = __webpack_public_path__ + "static/media/amazon_aws-icon.65750278.svg";